<template>
    <div class="multiTest">
        <h1 v-html="question.question"></h1>

        <ul>
            <li class="answer" v-for="(answers,index) in question.answers" :key="index" :class="{active: selected[index]}" @click="select(index)">
                <p><span>{{String.fromCharCode('a'.charCodeAt() + index)}}. </span>{{answers.answer}}</p>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data: () => {
        return {
            selected: [],
            that: this,
           }   
    },
    props: [
        'question'
    ],
    computed: {

    },
    mounted(){
        this.$store.state.buttonDisabled = false;
        var index = 0;
         for(var answer in this.question.answers){
            this.selected[index] = false;
            index++;
         }
    },
    methods: {
        select (index) {
            var vm = this;
            vm.$set(vm.selected, index, !vm.selected[index])
            this.$store.state.buttonDisabled = true;
        },
    },
    beforeDestroy() {
        var user_answer = []
        var index = 0;
        for(var select in this.selected){
            user_answer[index] = this.question.answers[select];
            index++;
        }
        var endDateSaveData = {
            'session_questions_fk': this.question.session_questions_id,
            'user_answer' : user_answer,
            'type' : this.question.type,
        }
        this.axios.put('/backend/web/end-question?access-token=' + this.$store.state.privateKey, endDateSaveData);    
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>